var styles = {"fontElementMap":"JQC6l","orderedlist":"fAeA9","bulletedlist":"ExUfy","listItem":"l0e6j"};

export { styles as s };
//# sourceMappingURL=lists-6420677a.js.map
